import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { changePageTitle } from 'src/domains/global/actions';
import Box from '@mui/material/Box';
import { SideSectionContaner, SideSection } from './SideSection';
import { Section } from './Section';
import { Job } from './Job';
import { Reference } from './Reference';
import { Avatar, NameTitle } from './Avatar';
import { SaaSPlatform } from './SaaSPlatform';

const About: React.FC = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(changePageTitle('System'));
    });

    return (
        <Box
            component="main"
            sx={{
                display: 'flex',
                justifyContent: 'center',
                minHeight: '100vh',
                flexDirection: 'row',
                backgroundColor: '#eee',
            }}
        >

            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: 820,
                    backgroundColor: '#fff',
                }}
            >
                <NameTitle />
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                    }}
                >

                    {/* --- SIDEBAR ------------------------*/}
                    <Box
                        id='sidebar'
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            width: '360px',
                            // backgroundColor: '#444',
                            pt: 2,
                        }}
                    >

                        {/* <Avatar /> */}

                        <Box
                            id='side-content'
                            sx={{
                                ml: 4,
                                // color: '#fff',
                            }}
                        >
                            <SideSectionContaner title='Contact' noMargin>
                                <SideSection title='Phone' text='(+1) 612-242-8696' />
                                <SideSection title='Email' text='miatlitski@gmail.com' />
                                <SideSection title='Address' text='1952 Lincoln Ln, Chanhassen MN 55317' />
                            </SideSectionContaner>

                            <SideSectionContaner title='Education'>
                                <SideSection title="Bachelor" text='Belarusian State University of Informatics and Radioelectronics' pretitle='2003' />
                            </SideSectionContaner>

                            <SideSectionContaner title='Expertise'>
                                <Box
                                    component='ul'
                                    sx={{
                                        listStylePosition: 'inside',
                                        padding: 0,
                                        fontSize: '0.9em',
                                    }}
                                >
                                    <li>Java EE</li>
                                    <li>JavaScript/TypeScript</li>
                                    <li>React/React Native</li>
                                    <li>Ext.js</li>
                                    <li>HTML/CSS</li>
                                    <li>RDBMS/MySql</li>
                                    <li>Hibernate</li>
                                    <li>Jboss/Tomcat</li>
                                    <li>Maven</li>
                                    <li>Docker/Kubernetes</li>
                                    <li>Git</li>
                                </Box>
                            </SideSectionContaner>

                            <SideSectionContaner title='Language'>
                                <SideSection text='English' />
                                <SideSection text='Russian' />
                                <SideSection text='Belarusian' />
                                <SideSection text='Ukranian' />
                            </SideSectionContaner>
                        </Box>
                    </Box>

                    {/* --- MAIN ------------------------*/}
                    <Box
                        id='main'
                        sx={{
                            p: 3,
                            pt: 2,
                            width: '100%'
                        }}
                    >
                        <Section
                            title={'RESTApiCMS — Backend-as-a-Service Platform'}
                            noMargin
                        >
                            <SaaSPlatform/>
                        </Section>

                        <Section
                            title={'Experience'}
                            noMargin
                        >
                            <Job
                                title='Full Stack Developer'
                                company='Morgan Stanley'
                                url='www.morganstanely.com'
                                start={2022}
                                end={2026}
                                protocol='https'
                                accomplishments={[
                                    'Improved application security by identifying and remediating vulnerabilities through implementation of secure coding practices.',
                                    'Optimized server-side JSON processing, significantly improving API response performance.',
                                    'Designed and implemented full-stack solutions using Ext.js front-end and Java/Spring backend services.'
                                ]}
                            />
                            <Job
                                title='React Developer'
                                company='Church Community Builder'
                                url='www.churchcommunitybuilder.com'
                                start={2021}
                                end={2022}
                                accomplishments={[
                                    'Developed reusable React components and integrated them into the legacy codebase.',
                                    'Created end-to-end integration tests for new functionality.',
                                    'Maintained a React Native mobile application.'
                                ]}
                            />
                            <div style={{ breakAfter: 'page' }}></div>
                            <Job
                                title='Front-end Developer'
                                company='SpecterOps'
                                url='www.specterops.io'
                                start={2020}
                                end={2021}
                                accomplishments={[
                                    'Developed high-performance reusable React components based on Material-UI.',
                                    'Built data-driven UI consuming REST APIs.',
                                    'Implemented data visualization using Regraph and Highcharts.',
                                    'Created unit tests (React Testing Library) and E2E tests using Cypress.',
                                ]}
                            />
                            <Job
                                title='Lead Full-stack Developer'
                                company='API Outsourcing'
                                url='www.apifao.com'
                                start={2016}
                                end={2020}
                                accomplishments={[
                                    'Developed a React single-page application.',
                                    'Integrated React components into a legacy Java / JSP system.',
                                    'Implemented SCIM specification as a configurable Java framework.',
                                    'Designed a configurable REST interface using Spring Data REST.',
                                    'Improved build pipeline to support CI/CD practices.',  
                                ]}
                            />
                        </Section>

                        <Section
                            title={'Earlier Engineering Experience'}
                            noMargin
                        >
                            <Job
                                title='Tech Lead | Consultant'
                                company='Coherent Solutions, Inc.'
                                url='www.coherentsolutions.com'
                                start={2013}
                                end={2016}
                                accomplishments={[
                                    'Led development teams, conducted code reviews, and designed enterprise software solutions.'
                                ]}
                            />
                            {/* <div style={{ breakAfter: 'page' }}></div> */}
                            <Job
                                title='Lead Developer | Software Analyst'
                                company='NMDP - National Marrow Donor Program'
                                url='www.bethematch.com'
                                start={2012}
                                end={2013}
                                accomplishments={[
                                    'Maintained AGNIS platform and modernized web-service architecture.'
                                ]}
                            />
                            <Job
                                title='Tech Lead | Consultant'
                                company='Coherent Solutions, Inc.'
                                url='www.coherentsolutions.com'
                                start={2011}
                                end={2012}
                            />
                            <Job
                                title='Senior Software Engineer'
                                company='ISSoft'
                                url='www.issoft.by'
                                start={2008}
                                end={2011}
                            />
                            <Job
                                title='Software Engineer'
                                company='ISSoft'
                                url='www.issoft.by'
                                start={2006}
                                end={2008}
                                last
                            />

                        </Section>

                        <Section
                            title={'Reference'}
                            noMargin
                        >
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'row'
                                }}
                            >
                                <Reference
                                    name='Rob Duff'
                                    position='Chief Operating Officer (COO)'
                                    company='Coherent Solutions'
                                    phone='(+1) 612-279-6263'
                                    email='robertd@coherentsolutions.com'
                                />
                                <Reference
                                    name='Joe Mullen'
                                    position='Senior Development Manager'
                                    company='API Outsourcing'
                                    phone='(+1) 651-675-2600'
                                    email='joe.mullen@caribouclan.us'
                                />
                            </Box>
                        </Section>
                    </Box>
                </Box>

            </Box>
        </Box>
    )
}

export default About;
